/**
 * Status-code classification sets for print lifecycle events, mirroring the
 * product Status Table (FE-10.1). QZ status callbacks surface these on
 * `PrinterStatus.statusText` / `PrinterEvent.statusText`.
 */

export const PRINT_STATUS_IN_FLIGHT = new Set<string>([
  'BUSY',
  'INITIALIZING',
  'POWER_SAVE',
  'PRINTING',
  'PROCESSING',
  'SCHEDULED',
  'SENT',
  'SPOOLING',
  'WAITING',
  'WARMING_UP',
]);

export const PRINT_STATUS_COMPLETED = new Set<string>(['COMPLETE', 'OK']);

/**
 * Terminal failure codes. Includes both "Printer error" (Retry button shown)
 * and "Printer needs attention" (no retry UI, but no label was produced — count
 * as failed for telemetry purposes).
 */
export const PRINT_STATUS_FAILED = new Set<string>([
  'ABORTED',
  'CANCELED',
  'DOOR_OPEN',
  'ERROR',
  'MANUAL_FEED',
  'NO_TONER',
  'NOT_AVAILABLE',
  'OFFLINE',
  'OUT_OF_MEMORY',
  'OUTPUT_BIN_FULL',
  'PAGE_PUNT',
  'PAPER_JAM',
  'PAPER_OUT',
  'PAPER_PROBLEM',
  'PAPEROUT',
  'PAUSED',
  'SERVER_UNKNOWN',
  'TONER_LOW',
  'UNKNOWN',
  'UNMAPPED',
  'USER_INTERVENTION',
]);

/** Default time after submitted before a print is auto-failed with TIMEOUT. */
export const PRINT_LIFECYCLE_TIMEOUT_MS = 30_000;
